import React from 'react';
import Button from 'material-ui/Button';


const Footer = () => {
        return (
            <footer className="app-footer">
                <div className="d-flex flex-row justify-content-between">
                    <div>
                        <span> © تمامی حقوق برای تولیتون محفوظ می باشد. </span>
                    </div>
                </div>
            </footer>
        );
    }
;

export default Footer;



// WEBPACK FOOTER //
// ./components/Footer/index.js